export default __webpack_public_path__ + "static/media/default-incoming-chat-sound.4c832aa9.mp3";